import { routes } from './clients.routes';
import SusEneListClientsController from "./directory/directory.controller";
import SusEneDetailsClientsController from "./details/details.controller";
export default angular.module('app.susene.clients', [])
    .config(routes)
    .controller('SusEneListClientsController', SusEneListClientsController)
    .controller('SusEneDetailsClientsController', SusEneDetailsClientsController)
    .name;
